import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const counter = {
  namespaced: true,
  state: {
    count: 0
  },
  getters: {
    doubleCount: (state) => state.count * 2
  },
  mutations: {
    increment(state) {
      state.count++
    }
  },
  actions: {
    increment({ commit }) {
      commit('increment')
    }
  }
}

const store = new Vuex.Store({
  modules: {
    counter
  }
})

export default store